<template>
  <v-row class="pa-0 " dense test-id="actions-transactions-models">
    <v-dialog v-if="cancelDialog" v-model="cancelDialog" width="600">
      <v-card class="pa-8 pb-4">
        <v-card-text>
          <v-row class="mb-4" dense justify="center">
            <v-icon color="var(--error)" large>warning</v-icon>
          </v-row>
          <p class="cts-font-size-2 text-center">{{
            $vuetify.lang.t("$vuetify.cancelTransactionAdvertisement")
          }}</p>
        </v-card-text>
        <v-card-actions>
          <v-row dense justify="center">
            <v-btn class="mr-2" color="var(--primary)" outlined @click="cancelDialog = false">
              {{ $vuetify.lang.t("$vuetify.back") }}
            </v-btn>
            <v-btn :loading="loadingCancel" color="var(--primary-alternative)" dark  @click="onCancelConfirm">
              {{ $vuetify.lang.t("$vuetify.cancelTransaction") }}
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-col>
      <v-card outlined>
        <v-card-text test-id="title-actions">
          {{ $vuetify.lang.t('$vuetify.actions') }}
          <v-divider class="my-2" />
          <v-row dense>
            <v-col class="pa-0">
              <v-row class="overflow-hidden" dense>
                <v-btn
                 test-id="download-certificate-btn"
                  :disabled="!transaction_content?.certification || transaction_content?.certification === '0' || transaction_content?.certification === '' || !checkPermission(const_permissions.TRANSACTION_DOWNLOAD_CERTIFICATE)"
                  :title="$vuetify.lang.t('$vuetify.downloadCertificate')" block class="cts-button-standard"
                  color="var(--primary-alternative)" small
                  @click="getTransactionCertification(transaction_content?.certification)">
                  <v-row dense justify="center">
                    {{ $vuetify.lang.t('$vuetify.downloadCertificate') }}
                  </v-row>
                </v-btn>
              </v-row>
              <v-row class="overflow-hidden" dense>
                <v-btn block class="cts-button-standard" test-id="tracking-btn"
                  v-if="transaction_content?.postamail_data && Object.values(transaction_content?.postamail_data)[0].tracking_url"
                  @click="openTracking()">
                  {{ $vuetify.lang.t('$vuetify.transactionTracking') }}
                  <v-icon aria-hidden="false" small>local_shipping
                  </v-icon>
                </v-btn>
              </v-row>
              <v-row class="overflow-hidden" dense>
                <v-btn test-id="download-pee-btn" block class="cts-button-standard " @click="downloadPEE()"
                  v-if="transaction_content?.postamail_data && Object.values(transaction_content?.postamail_data)[0].pee">
                  {{ $vuetify.lang.t('$vuetify.transactionDownloadPee') }}
                  <v-icon aria-hidden="false" small>approval</v-icon>
                </v-btn>
              </v-row>
              <v-row v-if="availableCancel && hasDigitalSignature" class="overflow-hidden" dense test-id="cancel-transaction-btn">
                <v-btn :disabled="!availableCancel" block class="cts-button-standard" color="var(--primary-alternative)"
                  small @click="cancelDialog = true">
                  {{ $vuetify.lang.t('$vuetify.cancelTransaction') }}
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      
    </v-col>
  </v-row>
</template>

<script>
import const_global from "@/constants/global";
import const_icons from "@/constants/icons";
import {  getTransactionPEE } from "@/services/transactionServices";
export default {
  name: "TransactionDetailActionsSection",

  data() {
    return {
      const_icons,
      const_global,
      eventsInfoDialog: false,
      loading: true,
      cancelDialog: false,
      loadingCancel: false,
    };
  },
  props: {
    transaction_content: Object,
    transactionStatus: Object,
    getTransactionCertification: Function,
    checkPermission: Function,
    const_permissions: Object,
    availableCancel: Boolean,
    cancelTransaction: Function,
    transactionModel: String,
  },
  computed: {
    hasDigitalSignature() {
      return this.transactionModel === 'digital_signature';        
    }
  },
  methods: {  
    async onCancelConfirm() {
    try {
      this.loadingCancel = true;
      await this.cancelTransaction(); 
      this.cancelDialog = false;     
    } catch (e) {
      console.error(e);
    } finally {
      this.loadingCancel = false;
    }
  },
    downloadPEE() {
      getTransactionPEE(Object.keys(this.transaction_content.postamail_data)[0]);
    },
    openTracking() {
      window.open(Object.values(this.transaction_content.postamail_data)[0].tracking_url, "_blank");
    },
  },
};
</script>
